export * from './grupo-tipo-abonado.component';
export * from './edit-grupo-tipo-abonado/edit-grupo-tipo-abonado.component';